<template>
  <component :is="component"></component>
</template>

<script>
import Alerts from '@/views/Alerts'
import AlertV2 from '@/views/AlertV2'
import { mapGetters } from 'vuex'

export default {
  components: {
    Alerts,
    AlertV2
  },
  computed: {
    ...mapGetters([
      'isV2'
    ]),
    component() {
      return this.isV2 ? AlertV2 : Alerts
    }
  }
}
</script>

<style></style>
